export const DEFAULT_LANGUAGE = "en";

export const SUPPORTED_LANGUAGES = ["en", "es", "fr", "de", "ja", "pl", "pt", "cs", "it"] as const;

export type SupportedLanguage = typeof SUPPORTED_LANGUAGES[number];

export const LANGUAGE_LABELS: Record<SupportedLanguage, string> = {
  en: "English",
  es: "Español",
  fr: "Français",
  de: "Deutsch",
  ja: "日本語",
  pl: "Polski",
  pt: "Português",
  cs: "Čeština",
  it: "Italiano",
};

export const isSupportedLanguage = (
  language: string
): language is SupportedLanguage => {
  return SUPPORTED_LANGUAGES.includes(language as SupportedLanguage);
};

export const getLanguageFromPath = (pathname: string): SupportedLanguage => {
  const firstPathSegment = pathname.split("/")[1];

  if (isSupportedLanguage(firstPathSegment)) {
    return firstPathSegment;
  }

  return DEFAULT_LANGUAGE;
};

export const removeLanguageFromPath = (pathname: string): string => {
  const parts = pathname.split("/");
  const firstPathSegment = parts[1];

  if (isSupportedLanguage(firstPathSegment)) {
    const pathWithoutLanguage = "/" + parts.slice(2).join("/");
    return pathWithoutLanguage === "/" ? "/" : pathWithoutLanguage.replace(/\/$/, "");
  }

  return pathname;
};

export const addLanguageToPath = (
  pathname: string,
  language: SupportedLanguage
): string => {
  const pathWithoutLanguage = removeLanguageFromPath(pathname);

  if (language === DEFAULT_LANGUAGE) {
    return pathWithoutLanguage;
  }

  if (pathWithoutLanguage === "/") {
    return `/${language}`;
  }

  return `/${language}${pathWithoutLanguage}`;
};
